// extracted by mini-css-extract-plugin
module.exports = {"container":"Ega0gYxPMYX0SpOar6fC8","logoWrapper":"QDDQsT6eHPiF8edyCIVFU","logo":"_5yAvQKmEy14UVF9VYETgP","mainContent":"xPv93wNP8klsddgfVGu5j","tags":"_2Wht8qon6S_nUSUt_5euMb"};